import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter } from 'rxjs/operators';
import { AbstractCmsBlockComponent } from '../../../../cms/block/abstract-cms-block.component';
import { CustomDropdownComponent } from '../../../../common/custom-dropdown/custom-dropdown.component';
import { IParentView } from '../view/layout/product-view-layout.abstract';
import { TSidebar } from '../view/layout/product-view-layout.interface';
import { productSizeGuideConfig } from './product-size-guide.config';
import { IProductSizeGuideContent } from './product-size-guide.interfaces';

@Component({
    selector: 'product-size-guide',
    templateUrl: './product-size-guide.component.html',
    styleUrl: './product-size-guide.component.scss',
    standalone: true,
    imports: [CommonModule, CustomDropdownComponent, ICmsClientModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductSizeGuideComponent>(productSizeGuideConfig)
export class ProductSizeGuideComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent, OnInit, OnDestroy {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductSizeGuideContent;
    selectedModal?: string = '';
    brandAttrValue?: string;
    sidebar!: TSidebar;

    readonly tableToggleId: NToggle.TId = ['table', 0];

    protected routerSubscription = new Subscription();
    protected toggleService = inject(ToggleService);
    protected router = inject(Router);

    @Input()
    parentView!: IParentView;

    get tableSelectState() {
        return this.toggleService.getState(this.tableToggleId);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.selectAttrValue();

        this.routerSubscription.add(
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
                this.selectAttrValue();
            })
        );
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.routerSubscription.unsubscribe();
    }

    onModelChange(): void {
        this.detectChanges();
    }

    selectTable(title: string): void {
        this.selectedModal = title;
        this.closeTableSelect();
        this.detectChanges();
    }

    toggleTableSelect(): void {
        this.toggleService.toggle(this.tableToggleId);
    }

    closeTableSelect(): void {
        this.toggleService.close(this.tableToggleId);
    }

    private prepareProductBrandAttr(): void {
        const brandFilterAttr = this.parentView?.product?.data?.brand_filter?.[0];

        if (brandFilterAttr) {
            this.brandAttrValue = optionLabelPipe(brandFilterAttr, 'brand_filter')?.toString();
        } else {
            this.brandAttrValue = undefined;
        }
    }

    private selectAttrValue(): void {
        this.timeoutService.setTimeout(() => {
            this.prepareProductBrandAttr();

            const brandFilterTable = this.content?.tables.find(table => table.title === this.brandAttrValue);
            this.selectedModal = brandFilterTable ? this.brandAttrValue : this.content?.tables[0]?.title;

            this.detectChanges();
        }, 1000);
    }
}
